export const initAOS = () => {
  return new Promise((resolve, reject) => {
    try {
      AOS.init({
        // グローバル設定:
        disable: 'mobile', // 次の値を受け入れます: 'phone', 'tablet', 'mobile', boolean, 式または関数
        startEvent: 'DOMContentLoaded', // ドキュメント上でディスパッチされるイベント名、AOSがこれに基づいて初期化されます
        initClassName: 'aos-init', // 初期化後に適用されるクラス
        animatedClassName: 'aos-animate', // アニメーションに適用されるクラス
        useClassNames: false, // trueにすると、スクロール時に `data-aos` の内容をクラスとして追加します
        disableMutationObserver: false, // 自動変異検出を無効にします (高度な設定)
        debounceDelay: 50, // ウィンドウサイズ変更時のデバウンスの遅延 (高度な設定)
        throttleDelay: 99, // ページスクロール時のスロットルの遅延 (高度な設定)

        // 各要素ごとに `data-aos-*` 属性で上書き可能な設定:
        offset: 0, // 元のトリガーポイントからのオフセット (px 単位)
        delay: 0, // 0 から 3000 の値、50ms ステップ
        duration: 1000, // 0 から 3000 の値、50ms ステップ
        easing: 'ease', // AOSアニメーションのデフォルトのイージング
        once: false, // アニメーションが一度だけ実行されるかどうか - 下にスクロール中
        mirror: false, // 要素がスクロールで通過するときにアニメーションが逆再生されるかどうか
        anchorPlacement: 'top-bottom', // 要素のどの位置がウィンドウに対してトリガーとなるかを定義します
      });
      console.log(`AOS initialized`);


      // 初期化が完了したことをPromiseで通知
      resolve(AOS);
    } catch (error) {
      reject(error);
    }
  });
};
